module.exports = __webpack_public_path__ + "img/2.20fd1298.png";